import React, { useState } from 'react'
import { CSmartTable } from '@coreui/react-pro'
import { toast } from 'react-toastify'
import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import RowActionsMenu from 'src/components/common/RowActionsMenu'
import GameNotificationService from 'src/service/GameNotificationService'
import Notify from '../Notify'
import { stripHtml } from 'src/utils/html'

const columns = [
  { key: 'title', label: 'Notification', filter: false, sorter: true },
  { key: 'created_at', label: 'Created', filter: false, sorter: true, _style: { width: '18%' } },
  { key: 'actions', label: 'Actions', filter: false, sorter: false, _style: { width: '1%' } },
]

const Table = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnSorter,
  loading,
  onEditNotification,
}) => {
  const [actionLoading, setActionLoading] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [tableId, setTableId] = useState(null)

  const deleteNotification = (id) => {
    setActionLoading(true)
    GameNotificationService.deleteNotification({ id })
      .then((res) => {
        if (res.status === 200) {
          toast.dismiss()
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .finally(() => setActionLoading(false))
  }

  const handleCancel = () => setShowConfirm(false)
  const handleConfirm = () => {
    deleteNotification(tableId)
    setShowConfirm(false)
  }
  const areYouSureModal = (id) => {
    setShowConfirm(true)
    setTableId(id)
  }

  const totalPages = Math.ceil((users?.total || 0) / itemsPerPage)

  return (
    <div className="ge-datatable ge-datatable--no-select">
      <CSmartTable
        columns={columns}
        columnSorter={{ external: true }}
        sorterValue={columnSorter}
        noItemsLabel="No notifications yet"
        scopedColumns={{
          title: (item) => {
            const preview = stripHtml(item.message)
            return (
              <td>
                <div className="d-flex flex-column gap-1">
                  <span
                    className="gn-notif-title"
                    role="button"
                    onClick={() => onEditNotification(item.id)}
                  >
                    {item.title}
                  </span>
                  {preview && (
                    <span className="gn-notif-preview">
                      {preview.length > 120 ? `${preview.slice(0, 120)}…` : preview}
                    </span>
                  )}
                </div>
              </td>
            )
          },
          created_at: (item) => (
            <td>{item.created_at ? moment(item.created_at).format('D.MM.YYYY') : '-'}</td>
          ),
          actions: (item) => (
            <td>
              <RowActionsMenu
                actions={[
                  { label: 'Edit', onClick: () => onEditNotification(item.id) },
                  {
                    label: 'Delete',
                    danger: true,
                    disabled: actionLoading,
                    onClick: () => areYouSureModal(item.id),
                  },
                ]}
              />
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading || actionLoading}
        pagination={{ external: true }}
        paginationProps={{
          activePage,
          pages: totalPages || 1,
        }}
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(page) => setActivePage(page)}
        onItemsPerPageChange={(perPage) => {
          setActivePage(1)
          setItemsPerPage(perPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        showConfirm={showConfirm}
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        text="Are you sure you want to delete this notification?"
      />
    </div>
  )
}

export default Table
